import { render, staticRenderFns } from "./app-forgot-password.vue?vue&type=template&id=28b7fbc2&scoped=true"
import script from "./app-forgot-password.vue?vue&type=script&lang=js"
export * from "./app-forgot-password.vue?vue&type=script&lang=js"
import style0 from "./app-forgot-password.vue?vue&type=style&index=0&id=28b7fbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7fbc2",
  null
  
)

export default component.exports